/* global ajaxFails */
import React, { Component } from 'react';
import { Link } from "react-router-dom";
import TopNav from '../components/TopNav';
import './Helper/helper';
// import 'jquery';
import Util from '../util/UtilClass';
import MenuItemModal from './modal/MenuItemModal';
import { Route } from 'react-router-dom';
import TableSessionHelper from '../Model/TableSession';
import { TableType } from '../components/merchant/Enum/TableType';
import MenuItemThumbnailImage from './components/MenuItemThumbnailImage';
import './MenuItem.scss';
import ModuleHelper, { moduleKey } from '../app/User/Helper/ModuleHelper';
import ReactHelper from '../util/ReactHelper';

export const IMG_HOT_ITEM = '/image/hot_item_icon.png';

const debugShowMenuItemId = window.debugSetting && window.debugSetting.user_app.menu_item_show_item_id
export const isPickupOrDelivery = (table) => {
    const tableBit = table.table_type_bitwise
    const notDineInWithPayment = (tableBit & TableType.BIT_DINE_IN_WITH_PAYMENT) == 0
    const isPickupOrDeliveryTable = (tableBit & (TableType.BIT_PICKUP | TableType.BIT_DELIVERY)) > 0

    // We need to take note here as DineInWithPayment table at the end is actually DineIn table, so we have to
    // use DineIn pricing
    return notDineInWithPayment && isPickupOrDeliveryTable
}

class MenuItemContent extends Component {
    constructor(props) {
        super(props)

        let categoryID;
        if (this.props.category != null) {
            // deprecated
            categoryID = this.props.category.id;
        } else {
            categoryID = this.props.match.params.categoryID;
        }
        this.state = {
            category: null,
            pin: Util.getRandomNumber(),
            orderingMenuItem: null,
            table: {
                id: table_id
            },
            tables: [],
            categories: [],
            menuItems: [],
            take_away: 0,
            variations: [],
            addons: [],
            options: [],
            selectedAddOns: [],
            selectedOptions: [],
            orderItems: [],
            orders: [],
            newMenuItem: {
                name: "",
                price: "",
                // merchant_id: props.merchant.id,
                table_id: table_id,
                category_id: categoryID
            },

            navHeight: "150px",

            outOfStockItem: {},
        }

        this.navRefs = React.createRef()
        this.menuListingRef = React.createRef()

        this.onBackButtonClicked = this.onBackButtonClicked.bind(this)
        this.billClicked = this.billClicked.bind(this)
        this.onItemBackButtonClicked = this.onItemBackButtonClicked.bind(this)
        this.getMenuListing = this.getMenuListing.bind(this)
        // this.getMenuModalButtons     = this.getMenuModalButtons.bind(this)
        // this.getMenuModalBody           = this.getMenuModalBody.bind(this)
        // this.handleNewMenuItemChange    = this.handleNewMenuItemChange.bind(this)
        this.menuItemSelected = this.menuItemSelected.bind(this)
        this.btnPlusClicked = this.btnPlusClicked.bind(this)
        this.btnMinusClicked = this.btnMinusClicked.bind(this)
        this.btnAddOnClicked = this.btnAddOnClicked.bind(this)
        this.btnOptionClicked = this.btnOptionClicked.bind(this)
        this.btnChoiceClicked = this.btnChoiceClicked.bind(this)

        this.getChoicesListing = this.getChoicesListing.bind(this)
        this.getVariationsListing = this.getVariationsListing.bind(this)
        this.getOptionsListing = this.getOptionsListing.bind(this)

        this.pickItem = this.pickItem.bind(this)
        this.getPinModalBody = this.getPinModalBody.bind(this)
        this.createTableSession = this.createTableSession.bind(this)
        this.showPinNumber = this.showPinNumber.bind(this);
    }

    componentDidMount() {
        this.props.app.loadTableIfNull(table_id)

        // We are using some custom logic here where menuListing will
        // only be rendered after TopNav is rendered successfully,
        // as we need some properties from TopNav to correctly position
        // menuListing.
        // However, on first render, after TopNav (navRefs) is rendered,
        // React attempts to render menuListing before navRefs is set
        // successfully, therefore menuListing is not rendered.
        //
        // If this is the case, we force React to rerender again after
        // navRefs is set
        if (this.navRefs.current && !this.menuListingRef.current) {
            this.forceUpdate()
        }
        this.updateNavHeight()
        this.updateOutOfStockItems()
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.app != undefined && this.props.app.state.categories != null && this.state.category === null) {
            let categories = this.props.app.state.categories;
            let selectedCategory;
            for (let category in categories) {
                if (categories[category].id == this.props.match.params.categoryID) {
                    selectedCategory = categories[category];
                    break;
                }
            }
            this.setState({
                category: selectedCategory
            });
        }
        this.updateNavHeight()

        if (ModuleHelper.moduleEnabled(moduleKey.INVENTORY)) {
            ReactHelper.handleComponentDidUpdate(this, ["menuItems", "orders"], () => {
                this.updateOutOfStockItems()
            })
        }
    }
    updateOutOfStockItems = () => {
        let _outOfStockItem = {};
        (this.props.app.state.menuItems || []).forEach((menuItem) => {
            const remainingQuantity = this.getRemainingQuantity(menuItem)
            let isInventoryOutOfStock = remainingQuantity < 1
            _outOfStockItem[menuItem.id] = isInventoryOutOfStock
        })
        this.setState(() => {
            return {
                outOfStockItem: _outOfStockItem
            }
        })
    }
    getRemainingQuantity = (menuItem) => {
        let remainingQuantity = 999 // Default we set to some large positive number
        if (menuItem && menuItem.track_inventory && ModuleHelper.moduleEnabled(moduleKey.INVENTORY)) {
            // If has inventory tracking, get remaining quantity
            remainingQuantity = menuItem.getInventoryRemainingQuantity()
        }
        return remainingQuantity
    }

    updateNavHeight = () => {
        if (this.navRefs.current && this.navRefs.current.navHeight) {
            let latestNavHeight = parseInt(this.navRefs.current.navHeight) + 20 + "px"
            if (this.state.navHeight != latestNavHeight) {
                this.setState({
                    navHeight: latestNavHeight
                })
            }
        }
    }

    isMenuItemShowImage = () => {
        let a = this.props.app.isMerchantHasFeature('menu_item_user_mode_show_image')
        return a
    }
    isItemOutOfStock = (menuItem) => {
        return this.state.outOfStockItem[menuItem.id] || menuItem.is_out_of_stock || menuItem.is_out_of_stock_until
    }
    getItemHeader(menuItem, allowUseMerchantImage, forceUseMerchantImage) {
        const isOutOfStock = this.isItemOutOfStock(menuItem)
        const isMenuItemShowImage = this.isMenuItemShowImage()
        const inventoryRemaining = this.getRemainingQuantity(menuItem)

        let itemPrice = null
        let selectedChoices = this.props.app.state.variation.selectedChoices.filter((item) => item.item_id == menuItem.id)
        const outOfStock = <span className="pull-right badge badge-secondary">{lang.sold_out}</span>
        const lowStock = !isOutOfStock && inventoryRemaining > 0 && inventoryRemaining <= 10 && <span className="pull-right badge badge-secondary badge-orange-override">{`Only ${inventoryRemaining} left`}</span>
        let isSubtitleExist = menuItem.subtitle && <span style={{ display: "-webkit-box", WebkitBoxOrient: "vertical", WebkitLineClamp: "2", textOverflow: "ellipsis", overflowY: "hidden", fontSize: "10px", color: "#909090", fontStyle: "italic", minWidth: "50%",  }}>{menuItem.subtitle}</span>
        if(selectedChoices.length == 0){
            const price = isPickupOrDelivery(this.props.app.state.table) && menuItem.price_delivery != null ? menuItem.price_delivery : menuItem.price
            itemPrice = <div>{this.props.currencyName+" " + (price * 1).toFixed(2)} {isOutOfStock && outOfStock} {lowStock}</div>
        }
        else{
            const choice = selectedChoices[0]
            const price = isPickupOrDelivery(this.props.app.state.table) && choice.price_delivery != null ? choice.price_delivery : choice.price
            itemPrice = <div>{this.props.currencyName+" " + (price * 1).toFixed(2)} {isOutOfStock && outOfStock} {lowStock}</div>
        }

        return (
            <>
                <div className="menu-item-row-content" style={{ fontWeight: "bold", display: "flex", alignItems: "center", paddingLeft: "0px", }}>
                    {isMenuItemShowImage &&
                        <span className="mr-3">
                            <MenuItemThumbnailImage menuItem={menuItem} allowUseMerchantImage={!!allowUseMerchantImage} forceUseMerchantImage={!!forceUseMerchantImage} />
                        </span>
                    }
                    <div className="item-detail">
                        <div style={{flex: "1 0 50px"}}>
                            {menuItem.hot_product == '1' ? <img src={IMG_HOT_ITEM} style={{ marginLeft: '5px', width:"18px", height:"18px" }} /> : <div style={{height: "18px"}}>&nbsp;</div>}
                            <div style={{ lineHeight: "1.25", display: "-webkit-box", WebkitBoxOrient: "vertical", WebkitLineClamp: "2", textOverflow: "ellipsis", overflowY: "hidden"}}>
                                <strong>{menuItem.name} {debugShowMenuItemId && ` (ID: ${menuItem.id})`}</strong>
                            </div>
                            <div style={{lineHeight: "1.15"}}>
                                {isSubtitleExist}
                            </div>
                        </div>
                        <div style={{ flex: "0 0 10px", fontWeight: "lighter", }}>
                            {itemPrice}
                        </div>
                    </div>
                </div>
            </>
        )
    }
    getMenuItemWithId(menuItemId) {
        let menuItem = this.props.app.state.menuItems.find((item) => item.id == menuItemId)
        return menuItem
    }
    menuItemSelected(e) {
        let id = e.currentTarget.dataset.id * 1
        let menuItem = this.getMenuItemWithId(id)

        if (this.isItemOutOfStock(menuItem)) {
            alert(lang.item_out_of_stock)
            return
        }

        this.setState({
            orderingMenuItem: menuItem
        })
        this.props.history.push(`/menu/${this.props.match.params.categoryID}/order/${id}/${this.props.match.params.tableQR}`)
        $(document).trigger('MenuItemContent.menuItemClicked')
    }

    getMenuListing() {
        let me = this
        let index = 0

        let menuItemList = this.props.app.state.filteredMenuItems
        menuItemList.sort(function(a,b) {return a.sequence - b.sequence})

        let style = {
            padding: {
                left: "8px"
            }
        }

        const forceUseMerchantImage = this.props.app.isMerchantHasFeature('force_use_merchant_menu_item_image_as_default_user_menu_item_image')
        const allowUseMerchantImage = this.props.app.isMerchantHasFeature('use_merchant_menu_item_image_as_default_user_menu_item_image')
        let li = menuItemList.map((menuItem) => {
            if (menuItem.category_id == null) {
                return ''
            }
            if (this.props.match.params.categoryID == menuItem.category_id && menuItem.active) {
                index++;
                if (!menuItem.is_section_header) {
                    return <li
                        id={`menu-item-${menuItem.id}`}
                        className={'list-group-item clearfix menu-item-row '}
                        data-index={index}
                        style={
                            {
                                verticalAlign: "middle",
                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                paddingLeft: style.padding.left,
                            }
                        }
                        key={menuItem.id}
                        onClick={(e) => {
                            // if table is lock .. click join table ... if join table success... open menu
                            let isNotYetJoinActiveTable = TableSessionHelper.isNeedToTriggerJoinTable()
                            if (isNotYetJoinActiveTable) {
                                this.props.app.setState({
                                    joiningTable: true
                                })
                            } else {
                                this.menuItemSelected(e)
                            }
                        }}
                        data-id={menuItem.id}>
                        {this.getItemHeader(menuItem, allowUseMerchantImage, forceUseMerchantImage)}
                    </li>
                }
                else {
                    return <li
                        key={menuItem.id}
                        data-id={menuItem.id}
                        style={{
                            listStyle: "none", marginTop: "20px",
                            backgroundColor: "rgba(255, 255, 255, 0.8)",
                            paddingLeft: style.padding.left,
                        }}>
                        {menuItem.name}
                    </li>
                }
            }
        })
        return li
    }


    onBackButtonClicked() {
        this.props.backClicked()
    }

    billClicked() {
        this.setState({
            checkOrder: true
        })
    }

    onItemBackButtonClicked() {
        this.setState({
            checkOrder: false
        })
    }

    getItemId() {
        let $itemCategory = this.state.category.id;
        let $itemName = $('#iname').val();

        // let menuItem = this.props.app.state.menuItems.find(item => item.category_id === itemCategory && item.name === itemName)
        let menuItem = this.props.app.state.menuItems.filter(function (item) {
            let $abc = (item.category_id == $itemCategory);
            let $xyz = (item.name == $itemName);
            if (item.category_id == $itemCategory && item.name == $itemName)
                return item;
        });

        return menuItem[0].id;
    }

    getPinModalBody() {
        return (
            <div style={{ witdh: "100%" }}>
                {/* <div id="category-title" className="category-modal-field">
                    <h3>{lang.category}: {this.state.category !== null ? this.state.category.name : ""} </h3>
                </div> */}
                <span style={{ fontSize: "20px", display: "block" }}>{lang.pin_random}</span>
                <span style={{ color: "red", fontWeight: "bold" }}><i>{lang.pin_random_desc}</i></span>
                <div style={{ textAlign: "center" }}>
                    <span id="random-number" style={{ fontSize: "60px", padding: "0 10px", fontWeight: "bold" }}></span>
                </div>
                <div style={{ width: "100%", height: "25px", borderBottom: "1px solid black", textAlign: "center" }}>
                    <span style={{ fontSize: "30px", backgroundColor: "#ffffff", padding: "0 10px" }}>Or</span>
                </div>
                <div style={{ marginTop: "40px" }}>
                    <span style={{ fontSize: "20px" }}>{lang.pin_enter}</span>
                </div>
                <div id="pin-value">
                    <div style={{ borderLeft: "6px solid black", height: "30%" }}></div>
                    {/* <input type="number" min="1" className="form-control" id="pin-input" placeholder={lang.hint_enter_pin}
                        onKeyDown={this.validate} pattern="\d{1,5}" /> */}
                    <input type="text" maxLength="4" value={this.state.pin || ""} onChange={this.pinChange.bind(this)}
                        className="form-control" id="pin-input" placeholder={lang.hint_enter_pin} />
                </div>
            </div>
        )
    }
    pinChange(value) {
        let regex = /^[0-9]{0,4}$/g
        if (regex.test(value)) {
            this.setState({
                pin: value
            })
        }
    }

    getConfirmOrderBody() {
        return (
            <div style={{ witdh: "100%" }}>
                <div id="order-title" className="category-modal-field">
                    {lang.asking_order}
                </div>
            </div>
        )
    }

    handleOrderQuantityChanged(menuItem, change) {
        switch (change) {
            case "+":
                menuItem.newOrderQuantity++
                break;
            case "-":
                // Handle make sure do not go zero
                menuItem.newOrderQuantity -= (menuItem.newOrderQuantity > 1) * 1
                break;
        }
        this.forceUpdate()
    }

    btnPlusClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let menuItem = this.getMenuItemWithId(id)
        this.handleOrderQuantityChanged(menuItem, '+')
    }

    btnMinusClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let menuItem = this.getMenuItemWithId(id)
        this.handleOrderQuantityChanged(menuItem, '-')
    }

    createTableSession(pin) {
        let me = this

        return new Promise(
            (resolve, reject) => {
                $.ajax({
                    url: "/table/" + me.props.app.state.table.id + "/join_table",
                    type: "post",
                    data: {
                        merchant_id: me.props.app.state.table.merchant_id,
                        table_id: me.props.app.state.table.id,
                        pin: pin,
                        merchant_menu_id: me.props.app.state.selectedMerchantMenuId
                    },
                    success: function (response) {
                        let message = lang.your_pin
                        let result = message.replace("*PIN*", pin)
                        alert(result)
                        table_session_id = response['id']
                        $('#table-pin-modal').modal('hide')
                        me.props.app.newSession();
                        resolve()
                        // me.forceUpdate()
                    },
                    fail: function (e) {
                        console.error(e)
                        alert(e)
                        reject()
                    }
                })
            })
    }

    pickItem(menuItem, animation = true) {
        if (menuItem.newOrderQuantity < 1) {
            return
        }

        let labelId = '#order-label-' + menuItem.id;
        let desc = $(labelId).text();

        let remarkId = '#order-remark-' + menuItem.id;
        let remarkValue = $(remarkId).val();

        let variations = '';
        let addons = this.props.app.state.variation.selectedAddOns.filter((item) => item.item_id == menuItem.id)
        if (addons.length > 0) {
            addons.map((addon) => {
                if (variations.length > 0)
                    variations = variations + ",";

                variations = variations + addon.name;
            })
        }

        let options = this.props.app.state.variation.selectedOptions.filter((item) => item.item_id == menuItem.id)
        if (options.length > 0) {
            options.map((option) => {
                if (variations.length > 0)
                    variations = variations + ", ";

                variations = variations + option.name;
            })
        }

        let totalPrice = this.getTotalPriceString(menuItem.id)//$('#total-price').text().replace("RM ", "");
        let isTakeAway = $('#checkbox-takeaway-' + menuItem.id).prop("checked") ? 1 : 0
        $.ajax({
            url: '/orders',
            type: 'post',
            data: {
                // order_session_id : session_id,
                menu_item_id: menuItem.id,
                quantity: menuItem.newOrderQuantity,
                remark: remarkValue,
                variations: variations,
                merchant_id: this.props.app.state.table.merchant_id,
                table_id: this.props.app.state.table.id,
                order_total: totalPrice,
                table_session_id: table_session_id,
                take_away: isTakeAway,
                desc: desc
            },
            success: (response) => {
                $('#place-order-button').fadeIn('slow');
            }
        }).fail(ajaxFails)
        if (animation) {
            this.animationMove(menuItem);
        }
    }

    animationMove(menuItem) {
        let btn = $('#btn-confirm-' + menuItem.id)
        let bottom = btn.offset().top - $('#bill-button').offset().top + 16
        let me = this
        btn.animate({
            bottom: bottom, height: "0%", width: "0%", opacity: '0.5', fontSize: "1px"
        },
            1000, function () {

                me.resetMenu(menuItem);
                me.forceUpdate()

                $('#bill-button').fadeOut(400, function () {
                    $('#bill-button').fadeIn(400);
                });
                $('#bill-count').fadeOut(400, function () {
                    $('#bill-count').fadeIn(400);
                });
            }
        );
    }

    resetMenu(menuItem) {
        let remarkId = '#order-remark-' + menuItem.id;
        $(remarkId).val("");

        menuItem.newOrderQuantity = 1

        var variation = this.props.app.state.variation;
        // variation.selectedChoices = [];
        variation.selectedAddOns = [];
        variation.selectedOptions = [];
        this.props.app.setState({
            variation: variation
        })
    }

    getChoicesListing(menuItem) {
        let listChoices = this.props.app.state.variation.choices
        listChoices.sort(function (a, b) { return a.sequence - b.sequence })
        let li = listChoices.filter(item => (item.item_id == menuItem.id)).map((choice) => {
            let value = (choice.price > 0) ? " " + (choice.price * 1).toFixed(2) : " " + (choice.price * 1).toFixed(2);
            return (this.props.app.state.variation.selectedChoices.indexOf(choice) > -1) ?
                <button key={choice.id} data-id={choice.id} style={{ marginLeft: "10px", marginBottom: "5px" }} type="button" className="btn btn-sm btn-primary" onClick={this.btnChoiceClicked}>{choice.name + value}</button> :
                <button key={choice.id} data-id={choice.id} style={{ marginLeft: "10px", marginBottom: "5px" }} type="button" className="btn btn-sm btn-default" onClick={this.btnChoiceClicked}>{choice.name + value}</button>
        })
        return li
    }

    getVariationsListing(menuItem) {
        let li = this.props.app.state.variation.addons.filter(item => (item.item_id == menuItem.id)).map((addon) => {
            let value = (addon.price > 0) ? " +" + (addon.price * 1).toFixed(2) : " " + (addon.price * 1).toFixed(2);
            return (this.props.app.state.variation.selectedAddOns.indexOf(addon) > -1) ?
                <button key={addon.id} data-id={addon.id} style={{ marginLeft: "10px", marginBottom: "5px" }} type="button" className="btn btn-sm btn-primary" onClick={this.btnAddOnClicked}>{addon.name + value}</button> :
                <button key={addon.id} data-id={addon.id} style={{ marginLeft: "10px", marginBottom: "5px" }} type="button" className="btn btn-sm btn-default" onClick={this.btnAddOnClicked}>{addon.name + value}</button>
        })
        return li
    }

    getOptionsListing(menuItem) {
        let li = this.props.app.state.variation.options.filter(item => (item.item_id == menuItem.id)).map((option) => {
            return (this.props.app.state.variation.selectedOptions.indexOf(option) > -1) ?
                <button key={option.id} data-id={option.id} style={{ marginLeft: "10px", marginBottom: "5px" }} type="button" className="btn btn-sm btn-primary" onClick={this.btnOptionClicked}>{option.name}</button> :
                <button key={option.id} data-id={option.id} style={{ marginLeft: "10px", marginBottom: "5px" }} type="button" className="btn btn-sm btn-default" onClick={this.btnOptionClicked}>{option.name}</button>
        })
        return li
    }

    btnChoiceClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let choice = this.props.app.state.variation.choices.find((item) => item.id == id)
        let menuItem = this.getMenuItemWithId(choice.item_id)

        //Clear choice
        let variation = this.props.app.state.variation;
        let selectedChoice = []
        let i = 0
        for (i = 0; i < variation.selectedChoices.length; i++) {
            if (variation.selectedChoices[i].item_id != choice.item_id) {
                selectedChoice.push(variation.selectedChoices[i])
            }
        }

        selectedChoice.push(choice)
        variation.selectedChoices = selectedChoice

        let totalPrice = parseFloat(choice.price);
        totalPrice = totalPrice * menuItem.newOrderQuantity;
        variation.totalPrice = totalPrice;

        this.props.app.setState({
            variation: variation
        })
    }

    btnAddOnClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let addon = this.props.app.state.variation.addons.find((item) => item.id == id)
        let menuItem = this.getMenuItemWithId(addon.item_id)

        let check = this.props.app.state.variation.selectedAddOns.find((item) => item.id == id)
        if (check == null || check.length == 0) {
            let variation = this.props.app.state.variation;
            variation.selectedAddOns.push(addon);

            let totalPrice = parseFloat(menuItem.price) + parseFloat(addon.price);
            totalPrice = totalPrice * menuItem.newOrderQuantity;
            variation.totalPrice = totalPrice;

            this.props.app.setState({
                variation: variation
            })
        }
        else {
            let res = []
            let totalPrice = parseFloat(menuItem.price);

            this.props.app.state.variation.selectedAddOns.forEach(function (selectedAddon) {
                if (selectedAddon.id != addon.id) {
                    res.push(selectedAddon)
                    totalPrice = totalPrice + parseFloat(selectedAddon.price)
                }
            });
            totalPrice = totalPrice * menuItem.newOrderQuantity

            let variation = this.props.app.state.variation;
            variation.selectedAddOns = res;
            variation.totalPrice = totalPrice;

            this.props.app.setState({
                variation: variation
            })
        }
    }

    btnOptionClicked(e) {
        e.stopPropagation()
        let id = e.currentTarget.dataset.id * 1
        let option = this.props.app.state.variation.options.find((item) => item.id == id)

        let check = this.props.app.state.variation.selectedOptions.find((item) => item.id == id)
        if (check == null || check.length == 0) {
            let variation = this.props.app.state.variation;
            variation.selectedOptions.push(option);

            this.props.app.setState({
                variation: variation
            })
        }
        else {
            let res = [];
            let variation = this.props.app.state.variation;
            this.props.app.state.variation.selectedOptions.forEach(function (selectedOption) {
                if (selectedOption.id != option.id)
                    res.push(selectedOption)
            });

            variation.selectedOptions = res;
            this.props.app.setState({
                variation: variation
            })
        }
    }

    showSelectedAddOns(selectedAddOns) {
        let li = selectedAddOns.map((addon) => {
            let value = (addon.price > 0) ? " +" + (addon.price * 1).toFixed(2) : " " + (addon.price * 1).toFixed(2);
            return <span key={addon.id} style={{ color: "red", display: "block", textAlign: "right" }}>{" " + addon.name + this.props.currencyName + " " + value}</span>
        })
        return li
    }

    showSelectedOptions(selectedOptions) {
        let li = selectedOptions.map((option) => {
            return <span key={option.id} style={{ color: "blue" }}>{" " + option.name}</span>
        })
        return li
    }

    enterRemark(menuItem) {
        let remarkId = "order-remark-" + menuItem.id;
        return <input key={menuItem.id} type="text" style={{ width: "260px" }} className="form-control" id={remarkId} maxLength="30" placeholder={lang.hint_max_char} />
    }

    getTotalPriceString(itemId) {
        let menuItem = this.getMenuItemWithId(itemId)

        let totalPrice = 0;
        let selectedChoices = this.props.app.state.variation.selectedChoices.filter((item) => item.item_id == itemId)
        if (selectedChoices.length > 0) {
            selectedChoices.map((choice) => {
                totalPrice = parseFloat(choice.price);
            })
        }
        else {
            totalPrice = parseFloat(menuItem.price);
        }

        if (this.props.app.state.variation.selectedAddOns.length > 0) {
            let selecteds = this.props.app.state.variation.selectedAddOns.filter((item) => item.item_id == itemId)
            selecteds.map((addon) => {
                totalPrice = totalPrice + parseFloat(addon.price);
            })
        }

        if ($('#checkbox-takeaway-' + menuItem.id).prop('checked')) {
            totalPrice = totalPrice + parseFloat(menuItem.take_away_charge)
        }

        totalPrice = totalPrice * menuItem.newOrderQuantity
        return (totalPrice * 1).toFixed(2)
    }

    getTotalPrice(itemId) {
        return <span key={itemId} id="total-price" style={{ fontWeight: "bold" }}>{this.props.currencyName} &nbsp; {this.getTotalPriceString(itemId)}</span>
    }

    getOrderBill(category) {
        let count = this.props.orders.length
        if (count > 0) {
            let draft = false
            let orderId = 0;
            this.props.orders.map((order) => {
                if (order.order_status == "draft") {
                    draft = true;
                    orderId = order.id;
                }
            })

            if (draft) {
                var flash = setInterval(function () {
                    $('#place-order-button').fadeTo('slow', 0.5).fadeTo('slow', 1.0);
                }, 3000)
            }
            else {
                clearInterval(flash);
            }

            return [
                <div key={"menu-" + category.id}>
                    <button id="bill-button" className="btn btn-default pull-right" onClick={this.billClicked}>{lang.my_order}</button>
                    <span id="bill-count" className="label label-danger pull-right order_dot" key={"table-" + this.props.table.id} style={{ marginRight: "10px", position: "absolute", right: "0px" }}>{count}</span>
                    <button id="place-order-button" data-id={orderId} key={orderId} style={{ display: draft ? "initial" : "none", marginRight: "5px" }} className="btn btn-danger pull-right" onClick={this.confirmedOrder}><strong>{lang.place_order}</strong></button>
                </div>
            ]
        }
        else
            return <button id="bill-button" className="btn btn-default pull-right" onClick={this.billClicked}>{lang.my_order}</button>;
    }

    showPinNumber() {
        alert(lang.your_pin_number + this.props.app.state.table_session.pin);
    }

    confirmedOrder(e) {
        if (confirm(lang.asking_place_order)) {
            e.stopPropagation()
            let id = e.currentTarget.dataset.id * 1
            let order = this.props.orders.find((item) => item.id == id)

            $('#place-order-button').fadeOut('slow');
            $.ajax({
                url: `/orders/${order.id}/update_order_status`,
                type: 'post',
                data: {
                    order_id: order.id,
                    merchant_id: order.merchant_id,
                    table_id: order.table_id,
                    order_status: "accepted"
                },
                success: (response) => {
                    alert(lang.order_complete)
                    console.log(response)
                }
            }).fail(ajaxFails)
        }
    }

    render() {
        if (!this.props.app.isReadyFor(this)) {
            return (<div></div>);
        }
        let image_path = (this.props.app.state.merchant && this.props.app.state.merchant.logo_url)?this.props.app.state.merchant.display_logo : "";
        let styling = this.props.app.isMerchantHasFeature('show_background_image_in_user_app')
        return (
            <div>
                {styling && <img src={image_path} style={{ position: "absolute", bottom: "50%", left: "50%", marginLeft: "-125px", marginBottom: "-125px", width: "250px", height: "250px", opacity: "0.4", zIndex: "0" }}/>}
                <Route path="/menu/:categoryID/order/:menuItemId/:tableQR" exact
                    render={({ history, match }) => {
                        let onDismissGoToUrl = `/menu/${match.params.categoryID}/${match.params.tableQR}`
                        return <MenuItemModal
                            app={this.props.app}
                            isPickupOrDelivery={isPickupOrDelivery(this.props.app.state.table)}
                            menuItem={this.getMenuItemWithId(match.params.menuItemId)}
                            onClose={() => {
                                this.props.history.replace(onDismissGoToUrl);
                            }}
                        />
                    }
                    } />
                <TopNav
                    ref={this.navRefs}
                    isAllowSearchbar={true}
                    tableQR={this.props.match.params.tableQR}
                    table={this.props.app.state.table}
                    topTitle={`${lang.category}: ${this.state.category !== null ? this.state.category.name : ""}`}
                    title={lang.menu_item}
                    orders={this.props.app.state.orders}
                    // action={this.addMenuItem}
                    actionLabel={this.props.app.state.isMerchant ? "+" : null}
                    back={"/category/" + this.props.match.params.tableQR}
                    // pin={this.props.app.state.table_session !== null && table_session_id !== null ? "(PIN: " + this.props.app.state.table_session.pin + ")" : ""}
                    pin={this.props.app.state.table_session !== null && table_session_id !== null ? <button className="btn btn-primary btn-sm" onClick={this.showPinNumber}>{lang.show_pin}</button> : ""}
                    session={this.props.app.state.current_session}
                    backLabel={lang.menu}
                    navbar={
                        <div className="scrollmenu text-center" id="category-tabs">
                            {
                                this.props.app.state.filteredCategories.map((category, index) => {
                                    if(category.active == 0){
                                        return "";
                                    }

                                    let selected = this.props.match.params.categoryID == category.id;
                                    return <Link
                                        ref={this.navRefs}
                                        //ref={`link_category_${category.id}`}
                                        className={`${selected ? "selected" : ""}`}
                                        style={{
                                            margin: "2px"
                                        }}
                                        to={`/menu/${category.id}/${this.props.match.params.tableQR}`}
                                        key={index}>{category.name}
                                    </Link>
                                })
                            }
                        </div>
                    }
                />
                {
                    <div ref={this.menuListingRef} className="container body-content" style={{ paddingTop: this.state.navHeight }}>
                        <ul id="menu-item-list" className="list-group">
                            {this.getMenuListing()}
                        </ul>
                    </div>
                }
            </div>
        )
    }
}
export default MenuItemContent;